<template>
	<div>
		我是费控中心
	</div>
</template>

<script>
	export default{
		name:'MyBill',
		data(){
			return {
				
			}
		}
	}
</script>

<style>
</style>
